export const transactionsStatus = [
    { id: 1, name: "Pendiente" },
    { id: 2, name: "Reclamado" },
  ]